var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconPickerInput',{attrs:{"value":_vm.modelVal},on:{"input":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }